import React from "react";

export const OffersIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <path d="M20.59 13.41L10.59 3.41C10.21 3.03 9.7 2.83 9.17 2.83H4C2.9 2.83 2 3.73 2 4.83V10c0 .53.21 1.04.59 1.41l10 10c.78.78 2.05.78 2.83 0l5.17-5.17c.78-.78.78-2.05 0-2.83zM6.5 7C5.67 7 5 6.33 5 5.5S5.67 4 6.5 4 8 4.67 8 5.5 7.33 7 6.5 7z" />
    </svg>
  );
};
